import { render, staticRenderFns } from "./productAdvantages.vue?vue&type=template&id=9e4fe3fa&scoped=true&"
import script from "./productAdvantages.vue?vue&type=script&lang=js&"
export * from "./productAdvantages.vue?vue&type=script&lang=js&"
import style0 from "./productAdvantages.vue?vue&type=style&index=0&id=9e4fe3fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4fe3fa",
  null
  
)

export default component.exports